<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: "sm" | "md" | "lg";
  label?: string;
  centered?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: "md",
  label: "",
  centered: false,
});

const sizeClass = computed(
  () => ({ sm: "h-3.5 w-3.5", md: "h-4 w-4", lg: "h-6 w-6" })[props.size],
);
</script>

<template>
  <div
    role="status"
    aria-live="polite"
    aria-busy="true"
    data-testid="loading-spinner"
    :class="['flex items-center gap-2 text-text-secondary text-sm', centered ? 'justify-center py-8' : '']"
  >
    <span class="spinner shrink-0 rounded-full" :class="sizeClass" aria-hidden="true"></span>
    <span v-if="label">{{ label }}</span>
  </div>
</template>

<style scoped>
.spinner {
  display: inline-block;
  border: 2px solid var(--color-spinner-border);
  border-top-color: var(--color-spinner);
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
